import React from "react";
import { LogOut, Menu, Download } from "lucide-react";
import { useAuth } from "../../context/AuthContext";
import { SystemHealthIndicator } from "../shared/SystemHealthIndicator";
import { Avatar, AvatarFallback } from "../ui/avatar";
import { Button } from "../ui/button";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger,
} from "../ui/dropdown-menu";
import { initials } from "../../lib/utils";
import { useInstallPrompt } from "../../hooks/useInstallPrompt";

export function Topbar({ onMenuClick }) {
  const { user, logout } = useAuth();
  const { canInstall, promptInstall } = useInstallPrompt();

  return (
    <header
      className="sticky top-0 z-40 flex h-16 min-h-[64px] items-center justify-between border-b border-border bg-surface px-4 sm:px-8 print:hidden"
      data-testid="app-topbar"
    >
      <button
        type="button"
        onClick={onMenuClick}
        className="rounded-md p-2 text-text-main hover:bg-background md:hidden"
        data-testid="mobile-nav-menu-button"
      >
        <Menu size={20} strokeWidth={1.75} />
      </button>
      <div className="hidden md:block" />
      <div className="flex items-center gap-2 sm:gap-3">
        {canInstall && (
          <Button
            variant="outline"
            size="sm"
            onClick={promptInstall}
            className="hidden sm:inline-flex"
            data-testid="install-app-button"
          >
            <Download size={14} strokeWidth={1.75} /> Install App
          </Button>
        )}
        {canInstall && (
          <button
            type="button"
            onClick={promptInstall}
            className="rounded-md p-2 text-text-main hover:bg-background sm:hidden"
            data-testid="install-app-button-mobile"
            title="Install App"
          >
            <Download size={18} strokeWidth={1.75} />
          </button>
        )}
        <SystemHealthIndicator />
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <button
              className="flex items-center gap-2 rounded-md px-2 py-1.5 transition-colors hover:bg-background"
              data-testid="user-menu-trigger"
            >
              <Avatar>
                <AvatarFallback>{initials(user?.username)}</AvatarFallback>
              </Avatar>
              <div className="hidden text-left sm:block">
                <p className="text-sm font-medium leading-none text-text-main">{user?.username}</p>
                <p className="text-[11px] capitalize leading-none text-text-muted">{user?.role}</p>
              </div>
            </button>
          </DropdownMenuTrigger>
          <DropdownMenuContent data-testid="user-menu-content">
            <DropdownMenuLabel>Signed in as {user?.email || user?.username}</DropdownMenuLabel>
            <DropdownMenuSeparator />
            <DropdownMenuItem data-testid="user-menu-logout" onClick={logout}>
              <LogOut size={16} strokeWidth={1.5} /> Log out
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
    </header>
  );
}
